// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file InputClearButton.tsx
 * @input Uses React, Button, Icon
 * @output Exports InputClearButton shared clear button for input components
 * @position Shared primitive; used by Typeahead, Tokenizer, TextInput
 */
import * as stylex from '@stylexjs/stylex';
import { Button } from "../Button/index.js";
import { Icon } from "../Icon/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
  button: {
    kZKoxP: "x1qx5ct2",
    kmuXW: "x2lah0s",
    $$css: true
  }
};
export function InputClearButton({
  label,
  onClick,
  xstyle
}) {
  return /*#__PURE__*/_jsx(Button, {
    variant: "ghost",
    size: "sm",
    label: label,
    icon: /*#__PURE__*/_jsx(Icon, {
      icon: "close",
      size: "sm",
      color: "inherit"
    }),
    onClick: onClick,
    isIconOnly: true,
    xstyle: [styles.button, xstyle]
  });
}
InputClearButton.displayName = 'InputClearButton';